import http from "@http"

//接口地址
let API = {
    //月报表接口
    MONTH_REPORT_URL : "/report/monthReport",
    //日报表接口
    DAY_REPORT_URL : "/report/monthReport",
   
}


//获取月报表
export function getMonthReport(data){
    return http.post(API.MONTH_REPORT_URL,data)
}

//获取日报表
export function getDayReport(data){
    return http.post(API.DAY_REPORT_URL,data)
}

